import { Box } from "@mui/material";
import React from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const StoreRankProgressBar = ({ percentage }) => {
  return (
    <Box mt={0.5} height={"140px"} width={"252px"} top={"408px"} left={"27px"}>
      <CircularProgressbar
        value={percentage}
        circleRatio={0.5}
        strokeWidth={24}
        showPercentValue={true}
        text={`${percentage} %`}
        styles={{
          root: {
            transform: "rotate(0.75turn)",
          },
          path: {
            stroke:
              percentage > 90
                ? "green"
                : percentage > 80
                ? "yellow"
                : "#D3392F",
            strokeLinecap: "butt",
          },
          trail: { stroke: "#C4C4C4", strokeLinecap: "butt" },
          trailColor: "grey",
          backgroundColor: "red",

          text: {
            writingMode: "vertical-rl",
            fontSize: "10px",
            fontWeight: "600",
          },
        }}
      />

      {/* Creating a progress bar  */}
      {/* <Box height={"155px"} width={"223px"} border={"1px solid black"}>
        <Box height={"150px"} width={"220px"} border={"1px solid blue"}>
          <Box
            height={"inherit"}
            width={"inherit"}
            border={"1px solid red"}
          ></Box>
        </Box>
      </Box> */}
    </Box>
  );
};

export default StoreRankProgressBar;
